import type { UserDto, UserSettingsDto } from "../../services/UserService";
import GroupId from "../../state/GroupId";
import type { User } from "../../state/user";
import UserId from "../../state/UserId";
import { toGrant } from "./grant";
import { TIMEZONES } from "../timeUtil";

const DEFAULT_TIMEZONE = "Etc/UTC";

const resolveTimezone = (timezone: string): string =>
  TIMEZONES.find(({ name }) => name === timezone)?.name ??
  TIMEZONES.find(({ group }) => group.includes(timezone))?.name ??
  DEFAULT_TIMEZONE;

export const toUser = (dto: UserDto): User => ({
  id: UserId.from(dto.id),
  username: dto.username,
  emailAddress: dto.emailAddress,
  firstName: dto.settings?.firstName ?? undefined,
  lastName: dto.settings?.lastName ?? undefined,
  language: dto.settings?.language ?? "en",
  timezone: resolveTimezone(dto.settings?.timeZone ?? DEFAULT_TIMEZONE),
  emailValidated: dto.emailValidated,
  grants: dto.grants.filter(({ customerId }) => customerId >= 0).map(toGrant),
  groups: dto.groups.map((groupId) => GroupId.from(groupId)),
  externallyManaged: dto.externallyManaged,
  disabled: dto.disabled,
  phoneNumber: dto.settings.phoneNumber ?? undefined,
  finishedTour: dto.settings.finishedTour,
  receiveNewsLetter: dto.settings.receiveNewsLetter,
});

export const toUserSettingsDto = (user: User): UserSettingsDto => ({
  finishedTour: user.finishedTour,
  firstName: user.firstName,
  language: user.language,
  lastName: user.lastName,
  phoneNumber: user.phoneNumber,
  receiveNewsLetter: user.receiveNewsLetter,
  timeZone: user.timezone,
});
